// ============================================================
// FILE NÀY CHỨA TOÀN BỘ NỘI DUNG CỦA WEBSITE
// Chỉnh sửa tại đây để cập nhật thông tin cá nhân
// ============================================================

export const PROFILE = {
  name: "Phùng Anh Duy",
  realName: "Phùng Anh Duy", // <-- đổi tên thật ở đây
  tagline: "Dược sĩ • Content Creator",
  bio: "Tốt nghiệp Dược sĩ (Đại học) & Digital Marketing thích theo đuổi Content, Design, edit Video và AI. Tôi tin rằng những kỹ năng mình đang xây có thể áp dụng cho mọi ngành cần sự sáng tạo và tỉ mỉ.  ",
  university: "Trường Đại học Nguyễn Tất Thành",
  major: "Dược sĩ (Hệ Đại học)",
  year: "Tốt nghiệp 08/2023",
  intro:
    "Tốt nghiệp Dược sĩ (Đại học) & Digital Marketing thích theo đuổi Content, Design, edit Video và AI. Tôi tin rằng những kỹ năng mình đang xây có thể áp dụng cho mọi ngành cần sự sáng tạo và tỉ mỉ.",
  location: "Quận Bình Tân, TP.HCM",
  location2: "Tiền Giang",
  phone: "0963 109 745",
  email: "anhduy.pharma@gmail.com", // <-- đổi email ở đây
  avatar: "/images/anhduy-blue tachnen.png", // <-- đặt đường dẫn ảnh ở đây, ví dụ: "/images/avatar.jpg"
  social: {
    tiktok: "https://tiktok.com/@lomoai",
    instagram: "https://instagram.com/lomoai",
    facebook: "https://facebook.com/anhduy.pharma",
    youtube: "https://youtube.com/@lomoai",
  },
};

export const BLOG_POSTS = [
  {
    id: 1,
    title:
      "Dùng AI đúng mục đích nhưng sai phương pháp: Đừng để não bộ của bạn phải trả giá cho sự tiện lợi này",
    date: "07/05/2026",
    category: "Góc nhìn",
    readTime: "8 phút đọc",
    thumbnail:
      "https://images.unsplash.com/photo-1655720828018-edd2daec9349?w=1200&q=80",
    thumbnailBg: "from-violet-100 to-purple-200",
    thumbnailEmoji: "🧠",
    summary:
      "Oxford chọn 'brain rot' là từ của năm 2024. Với AI tích hợp vào mọi ngóc ngách công việc sáng tạo, câu hỏi không còn là 'nên dùng AI không' mà là 'dùng như thế nào để không trả giá bằng chính khả năng tư duy của mình.'",
    impact:
      "Người dùng AI tốt nhất không phải người dùng AI nhiều nhất mà là người biết rõ khi nào effort của não mình tạo ra giá trị không thể thay thế.",
    tags: ["Góc nhìn", "Suy nghĩ"],
    content: `Cuối năm 2024, Oxford chọn "brain rot" là từ của năm.

Không phải ngẫu nhiên. Đây là lần đầu tiên trong lịch sử từ điển Oxford, từ được chọn không mô tả một khái niệm mới mà mô tả một quá trình suy thoái cụ thể là sự xuống cấp của trí tuệ và khả năng tư duy do tiêu thụ quá nhiều nội dung chất lượng thấp trên mạng.

Và bây giờ, với AI được tích hợp vào mọi ngóc ngách của công việc sáng tạo, câu hỏi không còn là "nên dùng AI không" mà là "dùng như thế nào để không trả giá bằng chính khả năng tư duy của mình."

[img:https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=900&q=80|AI và não bộ ranh giới giữa công cụ và sự phụ thuộc]

## Bằng chứng khoa học không phải để gây hoảng loạn, mà để hiểu đúng

Tháng 6/2025, nhóm nghiên cứu tại MIT Media Lab công bố một nghiên cứu có tên "Your Brain on ChatGPT". Họ chia 54 người tham gia thành ba nhóm: viết bằng não thuần túy, viết với công cụ tìm kiếm, và viết với ChatGPT. Mỗi người viết ba bài essay qua nhiều tháng. Nhóm dùng ChatGPT nhất quán cho thấy mức độ kết nối não thấp nhất alpha và theta wave, hai chỉ số đo mức độ tham gia nhận thức, giảm gần một nửa so với nhóm viết tay.

Đáng chú ý hơn là kết quả phiên thứ tư: khi nhóm ChatGPT bị chuyển sang viết không có công cụ, họ không thể nhớ lại chính xác những gì họ đã viết trước đó. Cảm giác "sở hữu" bài viết thấp nhất trong cả ba nhóm.

[callout:blue]⚠️ **Lưu ý:** Mẫu chỉ có 54 người, phạm vi hẹp (chỉ essay writing), và kết quả còn sơ bộ, chưa qua peer review. Đây không phải bằng chứng rằng dùng AI = mất não mà là bằng chứng rằng dùng AI **sai cách** có thể có chi phí nhận thức.[/callout]

Cùng lúc đó, một nghiên cứu từ Gerlich năm 2025 khảo sát 666 người thuộc nhiều độ tuổi cho thấy tương quan âm giữa tần suất dùng AI và khả năng tư duy phản biện, đặc biệt mạnh ở nhóm 17-25 tuổi. Microsoft công bố nghiên cứu trên knowledge workers và phát hiện rằng mức độ tự tin vào AI càng cao thì effort tư duy phản biện càng thấp.

## Brain rot từ AI trông như thế nào trong thực tế

Không ai tự nhận mình đang bị brain rot. Nó đến từ từ, không có thông báo.

[img:https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=900&q=80|Sự phụ thuộc vào công nghệ dấu hiệu xuất hiện dần dần]

**Dấu hiệu đầu tiên** thường là cảm giác ngại ngùng khi phải ngồi với một vấn đề chưa có câu trả lời rõ ràng. Trước đây bạn có thể ngồi brainstorm một mình 30 phút và ra được 10 ý. Bây giờ sau 5 phút bạn đã mở AI vì cảm thấy "không ra gì cả". Không phải não bạn kém hơn. Là bạn đã quen với việc được phục vụ câu trả lời ngay lập tức.

**Dấu hiệu thứ hai** là mất dần khả năng đọc dài. Bạn nhờ AI tóm tắt thay vì tự đọc một bài nghiên cứu. Lúc đầu vì tiết kiệm thời gian, hợp lý. Dần dần bạn không còn có thể đọc 3.000 từ liên tục mà không mất tập trung.

**Dấu hiệu thứ ba** là nội dung bạn tạo ra bắt đầu trở nên giống nhau. Không phải vì AI dùng lại từ ngữ, mà vì bạn không còn đưa nhiều perspective cá nhân vào nữa. AI điền vào chỗ trống, và chỗ trống đó trước đây là nơi insight của bạn sống.

**Dấu hiệu thứ tư**, khó nhận ra nhất: bạn bắt đầu hỏi AI những câu mà trước đây bạn sẽ tự trả lời sau vài phút nghĩ. "Tôi nên bắt đầu email này như thế nào?" Câu hỏi đó không cần AI. Não bạn biết câu trả lời. Nhưng bạn đã không cho nó cơ hội thử.

## Nghịch lý của công cụ tốt

Đây là nghịch lý mà ít ai nói ra: AI được thiết kế để giảm effort, và effort chính là thứ não bạn cần để phát triển.

[callout:amber]💡 Nguyên tắc "use it or lose it" trong neuroscience không phải metaphor. Những neural pathway không được dùng sẽ yếu dần không vĩnh viễn, nhưng đủ để tác động đến chất lượng công việc sáng tạo của bạn.[/callout]

Không phải mọi effort đều có giá trị. Gõ email hành chính hay làm spreadsheet báo cáo là effort nhưng không phát triển gì. Việc tốt nhất bạn có thể làm với những task đó là delegate cho AI càng nhiều càng tốt để dành effort cho nơi có giá trị hơn.

Nhưng những task như: hình thành một quan điểm về một vấn đề phức tạp, tìm ra ngách content chưa ai khai thác, viết hook câu đầu có tính cá nhân cao, quyết định strategic direction cho một dự án đây là những nơi effort của não bạn tạo ra giá trị thực mà AI không thể thay thế.

## Framework: chia task theo giá trị của effort

Trước khi mở AI cho bất kỳ task nào, tự hỏi một câu: **"Đây là loại task mà việc tôi tự làm sẽ giúp tôi giỏi hơn, hay là loại task mà tôi chỉ cần kết quả mà không cần quá trình?"**

[img:https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900&q=80|Phân loại công việc chìa khóa để dùng AI đúng cách]

**Nhóm 1 Delegate hoàn toàn cho AI:**

- Chuyển đổi format: bài blog thành LinkedIn post, email newsletter, script video
- Tóm tắt tài liệu thông tin: báo cáo ngành, số liệu thống kê
- Các task hành chính lặp đi lặp lại: template email, meeting agenda, summary cuộc họp
- Research facts: tìm số liệu, verify thông tin, tổng hợp nguồn

**Nhóm 2 AI chỉ được đóng vai thought partner:**

- Hình thành quan điểm và góc nhìn viết ra quan điểm của bạn trước, rồi mới dùng AI để test và phản bác
- Quyết định chiến lược dùng AI để liệt kê các factor, nhưng phán xét và quyết định phải là của bạn
- Viết phần quan trọng nhất của mọi bài: hook câu đầu, đoạn kết, điểm insight trung tâm
- Critique và phản biện output AI đừng accept ngay, hỏi: điều này đúng không? Còn thiếu gì?

## Kỹ thuật cụ thể: AI như thought partner, không phải answer machine

[callout:green]✅ **Thay vì:** *"Viết cho tôi một bài về X"*
**Dùng:** *"Tôi đang nghĩ về X theo hướng [quan điểm của bạn]. Phản biện lập luận này giúp tôi với. Tìm điểm yếu."*[/callout]

[callout:green]✅ **Thay vì:** *"Ý tưởng hay cho campaign về Y là gì?"*
**Dùng:** *"Tôi có 3 hướng sau cho campaign Y: [A, B, C]. Phân tích điểm mạnh và yếu của từng hướng. Đừng chọn hộ tôi."*[/callout]

[callout:green]✅ **Thay vì:** *"Tóm tắt bài này cho tôi"* (trước khi đọc)
**Dùng:** Đọc bài trước, sau đó hỏi AI: *"Những điểm tôi rút ra từ bài này là [X, Y, Z]. Tôi bỏ sót điều gì quan trọng không?"*[/callout]

Sự khác biệt ở chỗ nào? Ở cách đầu, não bạn đứng ngoài nhìn AI làm. Ở cách sau, não bạn đang làm và dùng AI như một đối thủ tập luyện, không phải như người chạy thay.

## Bảo vệ những khoảng trống trong ngày

[img:https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=900&q=80|Những khoảng trống yên tĩnh nơi ý tưởng thật sự được sinh ra]

Một trong những thứ bị đánh cắp âm thầm nhất khi dùng AI nhiều là **những khoảng trống không có nhiệm vụ**.

Trước đây, khi chờ cà phê, bạn nhìn ra cửa sổ và không làm gì. Khi đi bộ từ chỗ này sang chỗ kia, não bạn lang thang tự do. Đó là lúc những kết nối bất ngờ xảy ra một ý tưởng từ hôm qua kết hợp với một thứ bạn vừa đọc, tạo ra insight mà không có quy trình nào có thể tái tạo.

AI không lấy đi những khoảng trống đó trực tiếp. Nhưng mindset "luôn có thể productive hơn với AI" thì có. Bảo vệ những khoảng đó không phải anti-technology. Đó là điều kiện cần cho sự sáng tạo.

## Bài tập thực tế: thử một tuần "AI-delayed"

Không phải detox hoàn toàn, mà là delay. Mỗi khi bạn có impulse mở AI, chờ 10-15 phút và thử tự làm trước. Không cần hoàn chỉnh. Chỉ cần bắt đầu.

Sau một tuần, nhìn lại:

- Những lần nào bạn tự làm được tốt hơn dự kiến?
- Những lần nào AI thực sự không thể replace được?
- Những lần nào tự làm xong rồi mới mở AI thì nhận ra mình đã ra được ý tốt hơn AI?

Bài tập này không phải để prove bạn không cần AI. Mà để bạn biết chính xác AI cần thiết ở đâu và không cần thiết ở đâu với workflow cụ thể của mình.

## Điểm mấu chốt

Tốc độ không phải lúc nào cũng là mục tiêu. Có những công việc mà việc đi chậm hơn, vật lộn hơn, suy nghĩ kỹ hơn tạo ra output tốt hơn và giúp bạn giỏi hơn trong dài hạn.

[callout:purple]🧠 Nghiên cứu của MIT kết luận: tích hợp AI vào **giai đoạn sau** của quá trình tư duy sau khi não đã làm việc sâu với tài liệu thực ra có thể **hỗ trợ** tư duy phản biện thay vì cản trở. Vấn đề là ở thứ tự: **não trước, AI sau**.[/callout]

> Giỏi dùng AI không có nghĩa là dùng nhiều. Giỏi dùng AI có nghĩa là biết khi nào không dùng.`,
  },
  {
    id: 2,
    title:
      "Khi tư duy thiết kế có A.I + Workflow: Triển khai từ brief đến visual hiệu suất nhanh hơn",
    date: "07/05/2026",
    category: "Design",
    readTime: "",
    thumbnail:
      "https://images.unsplash.com/photo-1541462608143-67571c6738dd?w=1200&q=80",
    thumbnailBg: "from-blue-100 to-indigo-200",
    thumbnailEmoji: "🎨",
    summary:
      "Khách gửi brief lúc 9 giờ sáng. 11 giờ, bạn đã có 3 hướng concept hoàn chỉnh trên bàn. Không phải vì bạn giỏi hơn ai mà vì bạn đang chơi một ván cờ khác.",
    impact:
      "Design Thinking + A.I không phải tương lai của ngành sáng tạo đó là hiện tại mà người đi trước đang xây dựng lợi thế từng ngày.",
    tags: ["Design", "Workflow"],
    content: `> "Khách gửi brief lúc 9 giờ sáng. 11 giờ, bạn đã có 3 hướng concept hoàn chỉnh trên bàn. Không phải vì bạn giỏi hơn ai, mà vì bạn đang chơi một ván cờ khác."

## Nỗi đau mà không ai nói ra

Tôi từng mất 3 ngày cho một brief mà khách tóm gọn trong 2 câu.

*"Làm cho nó trông sang. Brand màu xanh. Khách hàng là người 30-45 tuổi."*

Nghe thì đơn giản. Nhưng từ chữ "sang" đến file thiết kế thực tế là cả một hành trình mà mọi designer, mọi freelancer, mọi creative director đều biết: mơ hồ, brainstorm loạn, revision không hồi kết, rồi giao sản phẩm trong trạng thái nửa hài lòng.

Đó không phải vấn đề về kỹ năng. Đó là vấn đề về **quy trình tư duy**.

Và đây là điều tôi nhận ra sau nhiều năm làm việc: phần lớn thời gian trong một dự án thiết kế không nằm ở việc *tạo ra*, mà nằm ở việc *quyết định sẽ tạo ra cái gì*.

[img:https://images.unsplash.com/photo-1501139083538-0139583c060f?w=900&q=80|Từ brief mơ hồ đến concept rõ ràng đó là khoảng cách mà tư duy thiết kế lấp đầy]

## Tư duy thiết kế không phải là vẽ đẹp

Trước khi nói đến A.I hay Freepik, cần làm rõ một điều: **Design Thinking** không phải kỹ năng của riêng designer.

Đây là framework 5 bước được Stanford d.school phát triển, được Google, IDEO, Apple áp dụng trong mọi quyết định sáng tạo:

[callout:blue]**Empathize › Define › Ideate › Prototype › Test**
Đồng cảm › Định nghĩa vấn đề › Phát triển ý tưởng › Tạo mẫu › Kiểm tra[/callout]

Với brief thiết kế thông thường, quy trình này thường bị bỏ qua hoàn toàn. Người ta nhảy thẳng từ brief vào Photoshop. Kết quả là revision lần 4, lần 5, lần 6. Khách không biết mình muốn gì vì designer chưa bao giờ giúp họ *định nghĩa* điều đó trước.

Đây là lỗ hổng lớn nhất trong workflow sáng tạo truyền thống.

## Câu hỏi sai lầm nhất khi A.I xuất hiện

Khi A.I image generation bùng nổ, phần lớn các cuộc tranh luận xoay quanh một câu hỏi duy nhất: *"A.I có thay thế designer không?"*

Câu hỏi đó sai.

Câu hỏi đúng hơn là: **A.I giải phóng mình khỏi phần nào của workflow để mình tập trung vào phần tạo ra giá trị thực sự?**

Tư duy thiết kế nằm ở Empathize, Define, Ideate. Đây là phần con người làm tốt nhất: phán đoán, đồng cảm, chiến lược thương hiệu, đọc được insight khách hàng. Không có prompt nào thay thế được những thứ đó.

Nhưng từ ý tưởng đến visual reference, mood board, prototype visual thì khác. Đây là phần A.I có thể làm trong vài phút thay vì vài giờ.

## Freepik Spaces không phải thư viện

Tháng 11/2025, Freepik ra mắt Spaces và đây là bước chuyển đánh dấu công ty không còn là kho stock assets nữa.

[img:/images/freepik-spaces.png|Freepik Spaces canvas vô tận để sáng tạo và cộng tác với AI workflow]

Vấn đề Spaces giải quyết có tên là **tool-hopping**: bạn generate ảnh ở Midjourney, tải xuống, upload lên Photoshop để chỉnh, xuất file, upload lên Figma làm mockup, xuất lại, gửi qua Slack cho khách, nhận feedback, rồi quay lại từ đầu. Mỗi lần chuyển tool là một lần mất context, mất thời gian, và đôi khi mất luôn cả mạch sáng tạo đang chạy trong đầu.

Kiến trúc cốt lõi của Spaces là **node-based interface trên infinite canvas** một mặt phẳng không giới hạn nơi bạn đặt các "node" và kết nối chúng thành workflow. Mỗi node đảm nhận một công việc cụ thể:

- **Upload Node** kéo ảnh và video từ máy vào thẳng canvas
- **Text Node** viết prompt, ghi chú, để lại comment cho team
- **Assistant Node** A.I mở rộng ý tưởng, cải thiện prompt
- **Image Generator** tạo visual từ text hoặc ảnh tham chiếu
- **Image Upscaler** tăng độ phân giải bằng công nghệ Magnific

[callout:amber]💰 Người dùng mới có thể tạo tối đa 3 Spaces miễn phí. Plan trả phí bắt đầu từ 5 euro/tháng với 84.000 AI credits một năm đủ để bắt đầu xây workflow thực tế trước khi quyết định đầu tư sâu hơn.[/callout]

## Workflow thực tế: từ brief 2 câu đến 3 hướng concept trong 2 giờ

**Bước 1 · Empathize: hỏi đúng trước khi làm gì (15 phút)**

Trước khi mở bất kỳ phần mềm nào, tôi dùng Spaces để brainstorm câu hỏi, không phải câu trả lời. Tôi đưa brief của khách vào Assistant Node và yêu cầu nó phân tích: brand này phục vụ ai, họ sợ gì, họ muốn trở thành ai trong mắt khách hàng?

15 phút đầu tư ở đây thường tiết kiệm được 3 giờ revision về sau.

**Bước 2 · Define: biến mơ hồ thành từ khóa (15 phút)**

Brief "sang trọng, màu xanh, 30-45 tuổi" được mở rộng thành cảm xúc: tin tưởng, ổn định, tinh tế, không phô trương. Visual language: clean lines, negative space lớn, màu xanh navy thay vì xanh điện. Và ghi rõ những thứ *không cần*: trendy, maximalist, streetwear, pastel.

**Bước 3 · Ideate: 3 hướng concept song song (45 phút)**

[img:https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=900&q=80|3 hướng concept song song trên cùng canvas thấy được sự khác biệt chiến lược ngay lập tức]

Thay vì phát triển 1 hướng rồi hy vọng khách thích, tôi xây 3 nhánh node song song trên cùng một canvas. Với brief "sang trọng, màu xanh, 30-45 tuổi":

- **Corporate Trust** navy blue và gold, editorial luxury, Swiss typography. Visual ra có cảm giác ngân hàng tư nhân châu Âu.
- **Modern Premium** deep teal và warm cream, Scandinavian minimal, photography-driven. Mood board ra có chiều sâu hơn, phù hợp brand lifestyle cao cấp.
- **Human Finance** warm navy và soft white, lifestyle photography, human-centric, cho affluent millennials. Hướng đi ấm hơn và gần người dùng hơn.

[callout:green]✅ A.I không quyết định hướng nào đúng. **Tôi quyết định.** Spaces chỉ rút ngắn thời gian từ ý tưởng trong đầu đến visual đủ rõ để trình bày từ vài ngày xuống còn vài chục phút.[/callout]

**Bước 4 · Prototype: hiện thực hóa hướng được chọn (30 phút)**

Sau khi khách chọn hướng, tôi dùng Spaces build nhanh prototype visual cho các touchpoint chính: hero banner, social post, key visual. Lúc này A.I đóng vai công cụ thực thi nhanh, giúp kiểm tra xem visual language đã chọn có hoạt động ở nhiều format khác nhau không.

**Bước 5 · Test: trình bày có chiến lược (15 phút)**

Bước cuối không phải về thiết kế mà về cách trình bày. Tôi không gửi file. Tôi kể một câu chuyện:

> *"Đây là 3 hướng. Hướng 1 phù hợp nếu mục tiêu của bạn là X. Hướng 2 mạnh hơn cho Y. Hướng 3 nếu bạn muốn Z. Tôi đề xuất hướng 2 vì..."*

Khách không chỉ chọn thiết kế, họ chọn chiến lược. Và khi họ hiểu lý do đằng sau, revision giảm xuống tối thiểu.

## Sau 6 tháng áp dụng, số thay đổi như thế nào

[callout:purple]📊 **Kết quả thực tế sau 6 tháng:**
- Thời gian từ brief đến concept trình bày: **2-3 ngày → 2-4 giờ**
- Số lần revision trung bình: **4-6 lần → 1-2 lần**
- Số dự án xử lý song song: **2-3 → 5-6 dự án**[/callout]

Nhưng quan trọng hơn con số, tôi bắt đầu được xem là người đồng hành chiến lược thay vì chỉ là người thực thi thiết kế. Đó là sự khác biệt lớn trong cách khách hàng định giá công việc.

## Một điều về prompt mà ít ai nói thẳng

Kết quả A.I tốt hay xấu phụ thuộc **80% vào cách bạn đặt câu hỏi**.

Prompt không phải là mô tả hình bạn muốn. Prompt là brief cho một junior designer cực kỳ nhanh nhưng thiếu kinh nghiệm thực tế. Bạn phải cho nó đủ context, đủ ràng buộc, và quan trọng nhất là nói rõ cái gì *không cần*.

Tư duy thiết kế dạy bạn đặt câu hỏi đúng trước khi tìm giải pháp. Freepik Spaces cho bạn công cụ để thực thi câu trả lời nhanh hơn bao giờ hết. Kết hợp hai cái đó lại không phải là tương lai của ngành đó là **hiện tại** mà người đi trước đang xây dựng lợi thế từng ngày.

> A.I không thay thế những người biết tư duy. A.I khuếch đại họ.`,
  },
  {
    id: 3,
    title: "Tối ưu chi phí sản xuất visual với Freepik Spaces và Higgsfield AI",
    date: "07/05/2026",
    category: "Design",
    readTime: "",
    thumbnail:
      "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=1200&q=80",
    thumbnailBg: "from-emerald-100 to-teal-200",
    thumbnailEmoji: "🎬",
    summary:
      "Trước đây, để sản xuất một bộ visual cho campaign đủ xài, bạn cần ít nhất 3-4 subscription riêng lẻ. Năm 2026, bài toán đó đang được giải theo một cách khác.",
    impact:
      "Freepik Spaces + Higgsfield AI = ~59 USD/tháng cho workflow đủ sản xuất cả image lẫn cinematic video. So với 126-220 triệu đồng nếu làm theo cách truyền thống.",
    tags: ["Design", "Workflow"],
    content: `Trước đây, để sản xuất một bộ visual cho một campaign đủ xài, bạn cần ít nhất 3-4 subscription riêng lẻ: một tool generate ảnh, một tool làm video, một nơi lưu trữ stock assets, một phần mềm edit. Cộng lại mỗi tháng không dưới vài triệu, chưa tính thời gian chuyển qua chuyển lại giữa các tab.

Năm 2026, bài toán đó đang được giải theo một cách khác.

Bài này không phải review tool. Đây là hướng dẫn thực tế về cách phân chia vai trò giữa **Freepik Spaces** và **Higgsfield AI** để xây workflow sản xuất visual đầy đủ mà không bị chồng chéo chi phí.

[img:https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=900&q=80|Workflow sản xuất visual hiện đại: từ brief đến deliverable trong vài giờ]

## Trước hết, Higgsfield là gì

Higgsfield AI ra mắt tháng 4/2025, được sáng lập bởi Alex Mashrabov (cựu trưởng bộ phận AI generative tại Snap) và Yerzat Dulat, nhà nghiên cứu AI chuyên về video generative. Đến đầu 2026, công ty đạt định giá khoảng 1.3 tỷ đô sau vòng Series A extension và báo cáo hơn 15 triệu người dùng, tạo ra khoảng 4.5 triệu video mỗi ngày.

Nói đơn giản: Higgsfield không phải là công cụ generate video thông thường. Nó là **multi-model aggregator** gom 15+ AI model video hàng đầu thế giới về một chỗ, bao gồm Sora 2, Google Veo 3.1, Kling 3.0, WAN 2.6, Seedance 2.0, tất cả dùng được trong một giao diện duy nhất.

[callout:blue]⚠️ **Cần nói thẳng:** Freepik cũng làm được video, và không phải video chất lượng thấp. Câu hỏi không phải "Freepik hay Higgsfield cho video?" mà là **mỗi cái mạnh hơn ở điểm nào** để phân bổ đúng việc cho đúng tool, tránh trả tiền hai lần cho cùng một thứ.[/callout]

## Cái Higgsfield làm tốt nhất

Điểm khác biệt lớn nhất của Higgsfield nằm ở **Cinema Studio và hệ thống camera control**. Thay vì generate ra video với camera cố định hoặc chuyển động ngẫu nhiên, Higgsfield mô phỏng gần như đúng ngữ pháp cinematography thực: dolly shots, crane moves, crash zoom, FPV sweeps, bullet time, orbital shots. Có hơn 70 camera preset khác nhau, mỗi preset encode một ngôn ngữ kể chuyện bằng hình ảnh riêng.

Các tính năng đáng chú ý khác:

- **Higgsfield Soul** cho phép tạo và quản lý nhân vật nhất quán qua nhiều clip, dùng để xây virtual influencer hoặc nhân vật brand
- **Lipsync Studio** tích hợp sync giọng nói vào nhân vật, phục vụ UGC-style ads hoặc explainer video
- **Click to Ad** nhận vào một link sản phẩm hoặc ảnh và tự động generate video quảng cáo
- **Sora 2 Trends** encode các viral structure đang trending vào preset, giúp generate clip phù hợp với thuật toán platform

## Pricing thực tế, không bỏ qua phần khó chịu

[callout:amber]💰 **Freepik** (billed annually):
- Essential: ~5-9 USD/tháng, 8.000 credits/tháng
- Premium: ~10-20 USD/tháng, 168.000 credits/năm
- Premium+: ~22.50 USD/tháng, 720.000 credits/năm
- Pro: ~143.75 USD/tháng, 3.6 triệu credits/năm[/callout]

[callout:purple]💰 **Higgsfield** (billed annually):
- Starter: 15 USD/tháng, 200 credits/tháng
- Plus: 39 USD/tháng, 1.000 credits/tháng, toàn bộ model
- Ultra: 99 USD/tháng, 3.000 credits/tháng
- Business: 49 USD/seat/tháng[/callout]

Credit consumption theo model trên Higgsfield:

- Kling 3.0: ~6 credits/video, hiệu quả nhất trong premium model
- Seedance 2.0: ~25 credits/clip
- Sora 2 / Veo 3.1: 40-70 credits/video, tốn nhất

[callout:blue]⚠️ **Lưu ý về "365-day unlimited":** Phần lớn các model được gọi là "unlimited" trên Higgsfield thực chất là image model, không phải video. Trong 8 model liệt kê là unlimited, 6 cái là image generator. Video model duy nhất truly unlimited là Soul V2, cũng là model cũ và chất lượng thấp nhất. Cần đọc kỹ trước khi đăng ký.[/callout]

## Vai trò từng tool trong workflow

**Freepik Spaces phù hợp cho:**

Toàn bộ giai đoạn ideation và asset production. Từ khi nhận brief đến lúc có visual assets đầy đủ, Spaces là nơi mọi thứ diễn ra trên một canvas: brainstorm bằng Text và Assistant Node, generate image references song song nhiều hướng, upscale bằng Magnific, lưu workflow thành template tái sử dụng.

Freepik Spaces cũng mạnh hơn rõ rệt ở phần **collaborative workflow**: toàn bộ brief nội bộ, feedback từ khách, lịch sử revision đều nằm trong cùng một canvas. Đây là thứ Higgsfield không có.

**Higgsfield phù hợp hơn khi:**

Bạn cần video có cinematic camera control thực sự. Cinema Studio cho phép stack tới 3 camera movement cùng lúc, chọn virtual lens và aperture, điều chỉnh theo genre (Action, Horror, Commercial, Noir...). Ngoài ra, Higgsfield mạnh hơn ở character consistency qua nhiều clip với Higgsfield Soul, lipsync cho dialogue-driven content, và Click to Ad khi cần generate nhiều ad variation nhanh.

[img:https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=900&q=80|So sánh chi phí: AI workflow vs. production truyền thống]

## So sánh thực tế: AI workflow với production truyền thống

Lấy ví dụ campaign thời trang: 5 key visual tĩnh cho IG feed + 3 video clip 10 giây cho Reels + 1 video hero 30 giây cho landing page.

[callout:green]📊 **Chi phí so sánh:**
- 5 key visual: 10-15 triệu (truyền thống) vs. included trong subscription (AI)
- 3 Reels clip 10 giây: 66-105 triệu vs. ~18 credits Kling 3.0 (~1 USD)
- 1 video hero 30 giây: 50-100 triệu vs. ~30-50 credits (~3-5 USD)
- **Tổng: 126-220 triệu đồng vs. ~1.5 triệu đồng/tháng**[/callout]

Nhưng đây không phải so sánh hoàn toàn công bằng. Production truyền thống cho ra visual với diễn viên thật, bối cảnh thật, ánh sáng được kiểm soát hoàn toàn. AI workflow hiện tại phù hợp hơn với social content, campaign testing, brand awareness giai đoạn đầu. Chất lượng đủ tốt cho Instagram, TikTok, Reels. Không thay thế được TVC truyền hình hay hình ảnh in ấn khổ lớn.

Điểm khác biệt thực sự không chỉ là tiền: với AI workflow, bạn chạy 3 hướng concept song song trong 2 giờ, để khách chọn trước khi đầu tư vào production thật. Hoặc deliver một bộ campaign trong 2 ngày khi deadline gấp.

## Cách phân bổ credit để không hụt giữa tháng

- Với Freepik: dùng mạnh cho image, hạn chế generate video vì credit consumption rất cao
- Với Higgsfield: dùng Kling 3.0 để test direction trước, chỉ chạy Sora 2 hay Veo 3.1 cho hero content thực sự cần chất lượng tối đa
- Dùng **Higgsfield Assist** để review prompt trước khi generate, giảm số lần phải regenerate

## Những thứ cần lưu ý trước khi đăng ký

[callout:amber]⚠️ Với Higgsfield, hãy chọn billing monthly trước khi chuyển sang annual. Cuối 2025 có khá nhiều báo cáo rằng checkout flow mặc định sang annual và người dùng bị charge toàn bộ năm mà không kịp nhận ra. Kiểm tra kỹ billing cycle trước khi confirm payment.[/callout]

Cả hai platform đều có free tier để test trước khi commit: Higgsfield có daily free credits qua Diffuse app, Freepik có 20 free image generation mỗi ngày. Dành vài ngày test thực tế trước khi quyết định plan nào phù hợp.

## Nhìn lại

Freepik Spaces và Higgsfield không phải đối thủ của nhau. Một bên mạnh về image workflow và collaborative production environment. Một bên mạnh về cinematic video với camera control thực sự có chiều sâu. Khi ghép lại, chúng cover được hầu hết nhu cầu sản xuất visual của một creative freelancer hoặc agency nhỏ mà không cần thêm công cụ thứ ba.

> Chi phí vào khoảng 60 USD/tháng cho cả hai. Câu hỏi không phải là "có đắt không" mà là "nếu không có workflow này, tôi sẽ tốn bao nhiêu thời gian và tiền để có cùng output đó?"`,
  },
  {
    id: 4,
    title:
      "Viết content bằng AI năm 2026: Dùng được không, dùng thế nào, và tại sao nghiên cứu thị trường mới là bước quan trọng nhất",
    date: "07/05/2026",
    category: "Content",
    readTime: "10 phút đọc",
    thumbnail:
      "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=900&q=80",
    thumbnailBg: null,
    thumbnailEmoji: null,
    summary:
      "97% content marketer có kế hoạch dùng AI năm 2026 nhưng 80% thất bại vì bỏ qua bước quan trọng nhất: nghiên cứu thị trường trước khi viết. Đây là framework thực tế.",
    impact:
      "Nếu bạn đang dùng AI để viết content, bước tạo ra khác biệt lớn nhất không phải là prompt hay tool mà là 90 phút research bằng Perplexity, ChatGPT và Claude trước khi gõ chữ đầu tiên.",
    tags: ["Content", "Góc nhìn"],
    content: `Có một sự thật mà hầu hết bài viết về AI content không dám nói thẳng: dùng AI để viết content thì dễ, nhưng viết được content tốt bằng AI thì khó hơn rất nhiều so với tự viết tay theo kiểu cũ.

Không phải vì AI kém. Mà vì hầu hết người dùng đang bỏ qua bước quan trọng nhất trước khi gõ bất kỳ từ nào.

Bài này sẽ đi thẳng vào ba câu hỏi: AI content có thực sự hiệu quả không, dùng như thế nào cho đúng, và tại sao nghiên cứu thị trường bằng AI trước khi viết lại là thứ tạo ra khác biệt lớn nhất.

[img:https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=900&q=80|Thực tế AI content năm 2026: nhiều người dùng, ít người dùng đúng]

## Bức tranh thực tế năm 2026

Theo nghiên cứu của Siege Media và Wynter năm 2026, 97% content marketer có kế hoạch dùng AI hỗ trợ công việc trong năm nay, tăng từ 83% của 2024. Đây không còn là xu hướng thử nghiệm, đây là thực tế vận hành của ngành.

Nhưng cũng trong cùng khoảng thời gian, một nghiên cứu phân tích 65.000 bài viết tiếng Anh cho thấy chỉ 14% nội dung đứng top trên Google là AI-generated. Ahrefs ghi nhận chỉ 13.5% content hoàn toàn do người viết đứng được ở top positions. Và một nghiên cứu SEO performance thực tế chỉ ra rằng human-written content tạo ra traffic gấp 5.44 lần và giữ người đọc lâu hơn 41% so với AI-generated content chưa được chỉnh sửa.

Ba con số này nói lên một điều: AI content nhiều, nhưng AI content tốt thì ít. Và chính vì nó nhiều, bar cho chất lượng đang bị nâng lên mỗi ngày.

[callout:blue]Vấn đề không phải là dùng AI hay không. Vấn đề là dùng AI ở đúng chỗ trong quy trình.[/callout]

## AI làm tốt được gì, và cái gì AI vẫn chưa làm được

Trước khi nói về workflow, cần hiểu rõ ranh giới năng lực thực tế của AI trong việc viết content năm 2026.

**AI làm tốt**

- **Xử lý khối lượng lớn nhanh.** Cái mà trước đây mất 3 ngày để research và draft, AI có thể rút ngắn xuống còn vài giờ.
- **Cấu trúc và outline.** AI cực giỏi tổ chức thông tin thành cấu trúc logic. Nếu bạn đã có insight và data, AI có thể biến chúng thành bộ khung bài viết rất nhanh.
- **Edit và cải thiện bản thảo.** Theo khảo sát 2026, lượng marketer dùng AI để edit đã tăng gấp đôi so với năm 2025, từ 19% lên 38%.
- **Biến thể và adaptation.** Một bài blog gốc có thể được AI biến thành caption IG, email newsletter, LinkedIn post, thread Twitter trong vài phút.
- **SEO optimization cơ bản.** Keyword placement, heading structure, meta description là những thứ AI làm ổn định và đáng tin cậy.

**AI vẫn chưa thay thế được**

- **Emotional intelligence và storytelling thật.** AI kể chuyện theo công thức. Người viết giỏi kể chuyện từ trải nghiệm sống. Sự khác biệt này người đọc cảm nhận được, dù họ không articulate được nó.
- **Insight từ trải nghiệm thực tế.** Một case study từ dự án bạn đã làm, một nhận xét từ cuộc gặp khách hàng tuần trước, một quan sát từ ngành mà bạn đang ngồi trong đó hàng ngày. AI không có những thứ này.
- **Judgment về những gì đang thực sự xảy ra trên thị trường.** AI biết những gì đã xảy ra, không biết những gì đang diễn ra ngay lúc này trong đầu khách hàng của bạn.
- **Quan điểm thực sự có chính kiến.** AI có xu hướng trình bày balanced, không chịu đứng về một phía. Content mạnh thường cần một góc nhìn rõ ràng và đôi khi gây tranh cãi.

## Lý do 80% người dùng AI content thất bại

Phần lớn người bắt đầu workflow AI content như này: mở ChatGPT, gõ "viết bài blog về [chủ đề]", copy kết quả, post lên.

Cái ra từ quy trình đó là content generic, đọc đúng nhưng không gây ấn tượng gì, không rank, không convert, không khiến ai share.

Lý do không phải AI kém. Lý do là người dùng bỏ qua hoàn toàn giai đoạn quan trọng nhất: **hiểu người đọc thực sự đang nghĩ gì, muốn gì, đang đặt câu hỏi gì** trước khi bắt đầu viết.

AI được train trên một lượng khổng lồ văn bản internet. Nếu bạn không cung cấp context cụ thể về audience và market, AI sẽ viết cho một người đọc trừu tượng, không tồn tại. Kết quả là content đúng mọi thứ nhưng không liên quan với ai cụ thể.

## Nghiên cứu thị trường bằng AI trước khi viết: tại sao và như thế nào

Đây là phần mà ít ai trong ngành content đang làm bài bản, và cũng là phần tạo ra khoảng cách lớn nhất giữa content trung bình và content thực sự hiệu quả.

**Perplexity: research engine cho giai đoạn khám phá**

Perplexity AI không phải công cụ viết, nó là công cụ research với citation thực. Không giống ChatGPT trả lời từ training data, Perplexity search web thực time và hiển thị nguồn cụ thể để bạn click vào verify.

Trong giai đoạn nghiên cứu trước khi viết, Perplexity có thể làm những việc sau trong vài chục phút:

- **Tìm hiểu ngôn ngữ thực tế của audience.** Hỏi Perplexity: "Người làm [ngành X] đang than phiền về điều gì nhất trên Reddit và forum chuyên ngành?" Kết quả cho bạn thấy ngôn ngữ thật của khách hàng, không phải ngôn ngữ của marketer viết về họ.
- **Phân tích những gì đang được đọc và share.** Hỏi: "Bài viết về [chủ đề] nào đang được share nhiều nhất trên LinkedIn và Twitter trong 30 ngày qua và tại sao?"
- **Phát hiện góc nhìn còn thiếu trên thị trường.** Hỏi: "Trong các bài viết phổ biến về [chủ đề], những câu hỏi nào của người đọc vẫn chưa được trả lời thỏa đáng?"
- **Cập nhật data và số liệu mới nhất.** Với Perplexity, bạn hỏi về số liệu ngành năm 2025-2026 và nhận được câu trả lời có cite source cụ thể.

[callout:amber]Lưu ý quan trọng: Perplexity vẫn có lỗi citation mismatch, khoảng 37% theo nghiên cứu của Columbia Journalism Review. Luôn click vào source gốc để verify trước khi dùng số liệu vào bài.[/callout]

**ChatGPT Deep Research: khi cần đào sâu một chủ đề**

ChatGPT với Deep Research mode (có từ Plus plan $20/tháng) có thể phân tích hàng chục tài liệu về một chủ đề và tổng hợp thành report trong vài phút.

Use case mạnh nhất cho giai đoạn research: upload các tài liệu internal của bạn (sales call transcript, customer feedback, survey result) và hỏi ChatGPT phân tích pattern. Đây là thứ Perplexity không làm được vì Perplexity chỉ search web, không phân tích tài liệu riêng của bạn.

**Claude: phân tích văn bản dài và tổng hợp ý**

Với context window 200K token, Claude có thể đọc và phân tích lượng văn bản rất lớn trong một session. Dùng Claude để tóm tắt và tổng hợp nhiều nguồn nghiên cứu bạn đã collect được, hoặc phân tích content của đối thủ cạnh tranh.

## Một quy trình research cụ thể 90 phút

[img:https://images.unsplash.com/photo-1434626881859-194d67b2b86f?w=900&q=80|90 phút research đúng cách tạo ra nền tảng cho content thực sự hiệu quả]

Đây là quy trình có thể áp dụng trước mỗi bài viết quan trọng:

**30 phút đầu với Perplexity:** search 5-7 query khác nhau về chủ đề từ góc nhìn của người đọc mục tiêu. Không phải hỏi "chủ đề X là gì" mà hỏi "người làm X đang gặp vấn đề gì, họ đang search gì, họ đang than phiền về gì." Collect tất cả kết quả vào một doc.

**30 phút tiếp với ChatGPT:** phân tích pattern từ data đã collect. Upload doc trên và hỏi: "Từ những thông tin này, đâu là 3 insight mạnh nhất về audience mà tôi nên dùng làm nền cho bài viết?" Kết quả là audience insight có căn cứ, không phải cảm tính.

**30 phút cuối với Claude:** dùng insight đã có để xác định góc tiếp cận bài viết. Hỏi Claude: "Tôi muốn viết về [chủ đề] cho [audience cụ thể] với những insight sau đây. Đâu là góc content mạnh nhất, khác biệt nhất so với những gì đã có trên market?" Claude thường đưa ra 3-4 hướng khác nhau, bạn chọn hướng phù hợp nhất.

Sau 90 phút này, bạn có: audience insight thực, góc content rõ ràng, và hiểu được content landscape của chủ đề.

## Dùng AI như thế nào cho đúng trong giai đoạn viết

**Cái bạn phải tự làm**

- Viết hook câu đầu. Đây là câu quan trọng nhất và cũng là câu AI viết dở nhất vì AI không có trải nghiệm thực để kéo vào.
- Đưa vào perspective và quan điểm của chính bạn.
- Fact-check mọi số liệu AI đưa ra. AI, kể cả với Perplexity, vẫn có thể fabricate hoặc distort số liệu.
- Viết kết bài. Phần kết cần cảm giác của người đã đi qua một hành trình cùng người đọc.

**Cái AI làm tốt hơn bạn trong giai đoạn viết**

- Expand một bullet point thành một đoạn đầy đủ.
- Tạo biến thể câu khi bạn thấy một đoạn đọc chưa hay.
- Clean up sau khi bạn viết draft.
- Repurpose sang các format khác: một bài blog 2.000 từ có thể được AI biến thành 10 LinkedIn post, 5 email sequence, 1 script video trong khoảng 1 giờ.

## Những dấu hiệu nhận biết AI vibe và cách tránh

Có những pattern ngôn ngữ AI hay lặp lại mà người đọc nhận ra dù không articulate được. Nhận ra chúng và tránh là bước edit quan trọng nhất sau khi dùng AI.

- **Mở đầu bằng câu tổng quát quá.** "Trong thế giới ngày nay..." hay "AI đang thay đổi mọi thứ..." Xóa đi và bắt đầu bằng điều cụ thể.
- **Cấu trúc liệt kê số quá nhiều.** AI thích chia mọi thứ thành "5 bước", "7 cách". Con người viết thường chảy hơn, mix giữa prose và list.
- **Tính năng bold quá nhiều.** AI thường bold rất nhiều cụm từ trong một đoạn. Người thật ít bold hơn và bold có chọn lọc hơn.
- **Từ "Ngoài ra", "Hơn nữa", "Bên cạnh đó" xuất hiện liên tục.** Đây là connector của AI, không phải của người viết thật.
- **Thiếu câu ngắn.** AI thường viết câu đều đều về độ dài. Người viết giỏi mix câu dài và câu cực ngắn để tạo nhịp.

## Số liệu thực về hiệu quả

Để không nói chay, đây là những con số từ nghiên cứu thực tế năm 2025-2026:

- Marketer dùng AI-generated content báo cáo conversion rate trên landing page tăng 36%.
- AI copywriting cải thiện click-through rate của ads trung bình 38% và giảm cost-per-click 32%.
- AI-assisted blog writing tăng organic traffic 120% trong 6 tháng.

Nhưng đây là con số cho **AI-assisted**, không phải fully AI-generated. Nghiên cứu từ Ahrefs cho thấy purely AI content rất hiếm khi đứng được ở position #1. Và content với original data và human insight báo cáo conversion rate cao hơn 64% so với content chỉ tổng hợp thông tin chung.

[callout:green]Khoảng cách giữa AI-assisted tốt và fully AI-generated dở không phải ở tool, mà ở người dùng tool đó biết gì và đưa vào bài bằng cách nào.[/callout]

## Tóm lại

AI content hiệu quả thực sự khi nó được dùng như một multiplier cho insight của người dùng, không phải như một replacement.

Quy trình đúng là: research thị trường kỹ bằng AI (Perplexity cho real-time data, ChatGPT cho phân tích tài liệu internal, Claude cho synthesis), xác định góc content có căn cứ, viết phần quan trọng nhất bằng tay (hook, insight cá nhân, kết bài), dùng AI để expand, polish, và repurpose.

Cái AI có thể làm tốt nhất cho bạn không phải là viết bài thay bạn. Mà là giúp bạn viết nhanh hơn, rộng hơn, và có chiến lược hơn, trong khi phần tạo ra kết nối thật với người đọc vẫn là của bạn.`,
  },
];

export const AI_EXPERIENCES = [
  {
    id: 1,
    title: "Lần đầu dùng ChatGPT: Mình hỏi nó viết luận nó viết hay hơn mình",
    date: "Tháng 9, 2024",
    emoji: "😱",
    bgColor: "from-sky-pastel to-blue-100",
    story: `Đó là một buổi tối deadline gấp. Mình mở ChatGPT lần đầu tiên trong đời, gõ vào: "Viết cho mình một bài luận 500 chữ về tác động của mạng xã hội đến giới trẻ."

Kết quả ra trong 8 giây. Mình đọc xong, ngồi thừ ra 2 phút.

Nó viết... hay hơn mình. Có luận điểm, có dẫn chứng, có kết luận. Mình vừa ngưỡng mộ vừa hơi tủi thân. Nhưng rồi mình nghĩ: "Ủa, mình có thể học từ cách nó viết không nhỉ?"

Và thế là mình bắt đầu hành trình không-biết-sẽ-đi-đâu với AI.`,
    lesson:
      "Bài học: AI không phải để thay thế mình. Nó là tấm gương để mình thấy mình cần cải thiện điểm nào.",
    tools: ["ChatGPT"],
  },
  {
    id: 2,
    title: "Lần đầu dùng Midjourney: Mình 'vẽ' logo cho dự án bằng... chữ",
    date: "Tháng 12, 2024",
    emoji: "🎨",
    bgColor: "from-mint-pastel to-green-100",
    story: `Nhóm mình cần làm logo cho project cuối kỳ mà không có ai biết thiết kế. Bạn cùng nhóm bảo: "Mày thử Midjourney đi, nghe nói nó vẽ được."

Mình gõ: "logo cute for a marketing team, pastel colors, minimalist" và nó ra ngay 4 cái ảnh đẹp tới mức cả nhóm nhìn nhau không nói được gì.

Sau đó mình dành 3 tiếng chỉ để thử các prompt khác nhau vì... thích quá.

Thầy hướng dẫn khen logo đẹp. Mình không dám nói là AI làm. Nhưng mình đã học được cách "nói chuyện" với AI để lấy được thứ mình muốn đó là kỹ năng thật sự.`,
    lesson:
      "Bài học: Prompt engineering không cần biết code. Chỉ cần biết mô tả thứ mình muốn một cách rõ ràng.",
    tools: ["Midjourney", "Canva AI"],
  },
  {
    id: 3,
    title: "Lần đầu dùng Notion AI: Tổ chức được cuộc đời lộn xộn của mình",
    date: "Tháng 2, 2025",
    emoji: "📋",
    bgColor: "from-beige-100 to-amber-100",
    story: `Mình vốn là người cực kỳ lộn xộn. Sổ tay đầy mà không tìm được gì. Notion thì cài rồi bỏ ba lần rồi.

Lần này mình thử Notion AI. Gõ tất cả ghi chú lộn xộn vào, rồi nhờ AI sắp xếp lại theo chủ đề.

Kết quả: 2 giờ sau mình có một hệ thống note gọn gàng nhất từ trước đến nay. Mình còn nhờ AI tạo template theo dõi việc học AI hằng tuần.

Bây giờ mình dùng Notion AI mỗi ngày để tóm tắt các bài đọc dài, brainstorm ideas và lên kế hoạch học tập.`,
    lesson:
      "Bài học: AI hữu ích nhất khi bạn dùng nó để giải quyết vấn đề thật của bản thân, không phải chỉ thử cho vui.",
    tools: ["Notion AI", "ChatGPT"],
  },
];

export const PROJECTS = [
  {
    id: 1,
    title: "Kế hoạch Marketing: Thuốc bổ sung sắt SATEX",
    description:
      "Bản kế hoạch marketing cho sản phẩm thuốc bổ sung sắt SATEX dành cho phụ nữ mang thai, bao gồm phân tích thị trường, SWOT, patient flow và chiến lược định vị. Dự án nghiên cứu, dữ liệu giả lập.",
    emoji: "💊",
    bg: "from-orange-100 to-amber-50",
    tags: ["Marketing", "Pharma", "Nghiên cứu"],
    status: "Hoàn thành",
    thumbnail: "/images/thumb-project-1.png",
    pdfUrl: "/pdfs/marketing-plan-1.pdf",
    content: `Đây là một phần bản kế hoạch marketing trong đồ án cho sản phẩm **SATEX**, thuốc bổ sung sắt dành cho phụ nữ mang thai. Dữ liệu trong bản kế hoạch mang tính giả lập phục vụ mục đích học thuật.

Điều thú vị là khi làm dự án này, mình nhận ra background Dược của mình có ích hơn mình nghĩ, hiểu được product concept, chỉ định, cơ chế phóng thích kéo dài, và đọc được dữ liệu thị trường mà không cần giải thích thêm.

## Bối cảnh sản phẩm

SATEX là thuốc bổ sung sắt (Sắt II sulfat 50mg + Acid folic) với công nghệ **phóng thích kéo dài**, điểm khác biệt chính so với các đối thủ. Ưu thế không phải giá rẻ hơn hay mạnh hơn, mà là **ít tác dụng phụ tiêu hóa hơn**, một insight rất quan trọng khi 70% bệnh nhân bỏ điều trị vì táo bón, buồn nôn.

## Insight cốt lõi tìm được

Khi phân tích patient flow theo mô hình McKinsey, mình thấy con số khá rõ: từ ~2 triệu phụ nữ có thai, chỉ ~251.000 người thực sự **tuân thủ điều trị** đến cuối. Đây chính là điểm rơi lớn nhất, và cũng là lý do SATEX nên định vị mạnh vào "compliance" thay vì chạy theo thị phần ban đầu.

## Phân tích cạnh tranh

Thị trường thuốc sắt bệnh viện đang tăng trưởng +33% trong khi kênh nhà thuốc giảm -7%. SATEX đang ở top 4 với ~6,2% thị phần, đối thủ chính là Ferlatum và HemoQmom. Điểm yếu rõ nhất: chỉ được chỉ định từ tháng thứ 4 thai kỳ, trong khi đối thủ tiếp cận bệnh nhân sớm hơn từ đầu thai kỳ.

## Chiến lược đề xuất

- **S1:** Tập trung kênh bệnh viện, nơi SATEX đang có 62% doanh thu và tăng trưởng tốt nhất
- **S2:** Mở rộng độ phủ nhà thuốc qua trade marketing
- **S3:** Launch SATEX 80mg để tiếp cận thêm nhóm khách hàng mới

## Điều mình học được

Làm kế hoạch marketing cho sản phẩm dược khác hoàn toàn so với consumer goods, người ra quyết định mua là **bác sĩ**, không phải bệnh nhân. Toàn bộ chiến lược phải xây quanh việc thuyết phục HCP (Healthcare Provider), không phải người dùng cuối. Đây là tư duy mình sẽ mang theo dù làm marketing trong lĩnh vực nào.`,
  },
  {
    id: 2,
    title: "Đồ án tốt nghiệp: Digital Marketing cho Affiliate sách",
    description:
      "Đồ án tốt nghiệp Digital Marketing tại Green Academy, xây dựng chiến lược Affiliate sách theo mô hình phễu TOFU/MOFU/BOFU trên Facebook Ads, Google Ads và TikTok Ads.",
    emoji: "📚",
    bg: "from-pink-100 to-rose-50",
    tags: ["Digital Marketing", "Affiliate", "Green Academy"],
    status: "Tốt nghiệp",
    thumbnail: "/images/thumb-project-2.jpg",
    pdfUrl: "/pdfs/do-an1.pdf",
    content: `Đây là đồ án tốt nghiệp khóa Digital Marketing tại Green Academy, tập trung xây dựng chiến lược Affiliate Marketing cho cuốn sách **"Làm chủ nhịp sinh học"** của Russell Foster trên các nền tảng Facebook, Google và TikTok.

Lý do chọn sách này không chỉ vì hợp xu hướng self-help mà vì nội dung có tính khoa học cao, dễ triển khai content theo phễu và phù hợp với video ngắn viral.

## Chiến lược cốt lõi

Toàn bộ đồ án xây dựng theo nguyên tắc **"không bán sách ngay từ đầu"**, thay vào đó đi theo hành trình:

- **TOFU:** Đánh vào pain point (burnout, mất ngủ, mệt mỏi dù ngủ đủ giấc) để khơi gợi vấn đề và tạo đồng cảm
- **MOFU:** Giáo dục khách hàng qua review sách, tóm tắt nội dung, case study, xây niềm tin dần
- **BOFU:** Chốt sale bằng CTA rõ ràng, ảnh thật, affiliate link trực tiếp trên Shopee/TikTok Shop

## Insight khách hàng

Tệp mục tiêu là sinh viên, nhân viên văn phòng 18-35 tuổi quan tâm sức khỏe và năng suất. Điểm thú vị là hành vi mua của họ rất rõ: xem video ngắn, tin review cá nhân hơn quảng cáo, và quyết định mua nhanh khi có freeship và CTA tốt.

## Triển khai Ads theo phễu

Facebook Ads TOFU target rộng với Reels 10-15 giây, ngân sách 50-80k/ngày, KPI CPM dưới 40.000đ. MOFU remarketing người đã tương tác, tập trung tăng CTR và thời gian xem. Đồ án cũng triển khai tương tự trên Google Ads và TikTok Ads với lịch content 30 ngày xen kẽ các tầng phễu.

## Điều mình học được

Affiliate Marketing trông đơn giản nhưng đòi hỏi tư duy phễu rất kỹ. Bán được một cuốn sách không phải chuyện một video là xong, mà là cả một hành trình từ lúc khách chưa biết vấn đề của mình đến khi họ sẵn sàng bỏ tiền ra. Đồ án này giúp mình hiểu rõ hơn cách xây content có mục tiêu, không chỉ làm cho vui.`,
  },
  {
    id: 3,
    title: "Dịch thuật bài báo cáo nghiên cứu khoa học: Adverse drug reactions induced by cardiovascular drugs in outpatients",
    description:
      "Bản dịch tiếng Việt bài báo nghiên cứu quốc tế \"Adverse drug reactions induced by cardiovascular drugs in outpatients\", thực hiện năm 3 Đại học, rèn luyện khả năng đọc hiểu và chuyển ngữ tài liệu y khoa chuyên ngành.",
    emoji: "📄",
    bg: "from-sky-100 to-blue-50",
    thumbnail: "https://images.unsplash.com/photo-1460672985063-6764ac8b9c74?w=800&q=80",
    tags: ["Dược học", "Nghiên cứu", "Dịch thuật"],
    status: "Hoàn thành",
    content: `Bản dịch tiếng Việt bài báo nghiên cứu quốc tế thực hiện trong năm 3 Đại học tại Trường Đại học Nguyễn Tất Thành. Nghiên cứu khảo sát các phản ứng có hại của thuốc (ADR) do nhóm thuốc tim mạch gây ra trên bệnh nhân điều trị ngoại trú, nhóm bệnh nhân thường dùng thuốc dài hạn, đa thuốc và ít được giám sát chặt chẽ.

## Tài liệu

[Xem bài báo gốc (tiếng Anh)](https://drive.google.com/file/d/18R_CjrbJbyGfw59uLVCQMaHKBUSfBs08/view)

[Xem bản dịch tiếng Việt](https://drive.google.com/file/d/1zqgSDl8swTwACcfGAU08lJagpTO8Zy0M/view)`,
  },
  {
    id: 4,
    title: "Content Writing TPCN: DHA, Isoflavon & Omega-3",
    description:
      "Bộ 3 bài viết content dược phẩm / thực phẩm chức năng: DHA cho trẻ em, Isoflavon – Tinh dầu hoa anh thảo – Sâm cho phụ nữ, và quảng cáo Triple Strength Omega-3.",
    emoji: "💊",
    bg: "from-green-100 to-teal-50",
    thumbnail: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80",
    tags: ["Content Writing", "Dược phẩm", "TPCN"],
    status: "Hoàn thành",
    content: `Bộ 3 bài content dược phẩm viết cho nhóm sản phẩm thực phẩm chức năng, ứng dụng kiến thức Dược học vào copywriting chuyên ngành. Mỗi bài đảm bảo tính khoa học, dễ đọc và phù hợp với từng nhóm đối tượng mục tiêu.

## Bài 1 — DHA: Dinh dưỡng thiết yếu cho sự phát triển toàn diện của bé

Đối tượng: Cha mẹ có con nhỏ. Nội dung phân tích vai trò của DHA đối với não bộ, thị giác, hệ miễn dịch và tim mạch của trẻ; hướng dẫn nguồn bổ sung tự nhiên và TPCN kèm lưu ý an toàn khi dùng cho trẻ.

[Xem bài viết Sample 1 (PDF)](https://drive.google.com/file/d/137vE-rBQDmc08a_jPms8ot_5TgLCr5Py/view)

## Bài 2 — Isoflavon, Tinh dầu hoa anh thảo và Sâm: Bí quyết cho phụ nữ tự tin và quyến rũ

Đối tượng: Phụ nữ tiền mãn kinh và mãn kinh. Nội dung so sánh cơ chế tác dụng của 3 nhóm hoạt chất hỗ trợ sinh lý nữ, giúp người đọc lựa chọn sản phẩm phù hợp với nhu cầu cụ thể.

[Xem bài viết Sample 2 (PDF)](https://drive.google.com/file/d/1u1TlD0Xe9SfF8mtOuQh5-AxCdHPfrt8w/view)

## Bài 3 — Triple Strength Omega-3: Quảng cáo ngắn

Đối tượng: Người dùng chăm sóc sức khỏe tim mạch và não bộ. Đây là bài content quảng cáo ngắn theo format social media, nhấn mạnh lợi ích vượt trội của hàm lượng EPA & DHA cao gấp 3 lần sản phẩm thông thường.

[Xem bài viết Sample 3 (PDF)](https://drive.google.com/file/d/18VlzZlfP6ksvbZEKSF5jXIXWkCbcpagb/view)`,
  },
  {
    id: 5,
    title: "Visual AI: Campaign Hero cho nước hoa Valaya",
    description:
      "Thiết kế hình ảnh campaign hero cho thương hiệu nước hoa luxury Valaya theo phong cách couture minimalism, dùng Midjourney và Magnific AI để tạo visual đạt chuẩn editorial.",
    emoji: "🎨",
    bg: "from-purple-100 to-violet-50",
    thumbnail: "/images/magnific-1.png",
    tags: ["Midjourney", "Magnific AI", "Luxury Design"],
    status: "Hoàn thành",
    content: `## Brief

PROJECT OVERVIEW: Product/service type: luxury eau de parfum; Brand (visible): Valaya / Parfums de Marly (Paris); Category & purpose of the image: premium fragrance hero ad, brand-building creative that presents the bottle as couture object and communicates refinement for advertising, editorial spreads, ecommerce hero and campaign hero visuals.

PROBLEM STATEMENT: What problem this visual solves: differentiates a new/hero scent in a crowded luxury fragrance market by turning the bottle into an aspirational object and conveying olfactory qualities visually; Why the brand exists: to offer heritage-rooted, couture luxury fragrances that signal status and refined taste; Market need addressed: consumers seeking a feminine, understated yet unmistakably premium perfume experience and a tactile-luxury product narrative that justifies price and builds desirability.

CORE CONCEPT: Main creative idea: purity and quiet prestige, a matte-white sculptural bottle emerges from diaphanous veil, combining softness (sheer fabric, skin) with cold luxury (silver cap, metal cuff); Symbolism/metaphors: veil for mystery and intimacy, white bottle for purity and modern couture, silver elements for craftsmanship and aristocratic lineage; Key theme: ethereal-luxury / couture minimalism.

TARGET AUDIENCE: Age/gender: women, primarily 25–45; Lifestyle & behaviors: urban, affluent or aspirational, fashion-aware, purchases influenced by aesthetics and heritage, values tactile quality and understated status symbols; Preferences & media habits: engages with luxury editorials, premium social media feeds (Instagram), boutique retail experiences; Emotional triggers & insights: desire to feel elegant, discreetly noticed, to own something that signals refined taste without ostentation.

KEY MESSAGE: Main message: Valaya is a refined, couture-quality perfume that embodies purity, subtle seduction and aristocratic finesse; Supporting messages: craftsmanship and heritage (Paris), tactile luxury (matte bottle, tassel, metalwork), intimacy and mystery (veil); Tagline/text meaning (visible): VALAYA, positions the name as the signature, "PARFUMS de MARLY PARIS" signals provenance and heritage.

VISUAL STRATEGY: Composition: tight portrait crop with bottle foregrounded at center, partially overlapping model's chest and hand to link product and wearer; Framing & subject placement: model cropped at lower face to imply sensuality without direct identity, bottle positioned central and slightly lower to anchor composition; Color palette: dominant soft ivory/pearl whites, warm skin tones, pale blush and cool silver accents; Lighting: high-key, diffuse soft light from front-left creating luminous skin and translucent fabric highlights, minimal shadows for an airy feel; Materials & textures: sheer chiffon/veil for ethereality; matte porcelain-like bottle body for understated luxury; polished silver cap and cuff for contrast and premium finish; tassel adds tactile couture detail; Depth, focus & camera angle: shallow depth of field with sharp product and slightly softer model to prioritize object; frontal mid-close angle to create intimacy and product prominence.

STYLE DNA: Visual style keywords: ethereal-luxury, couture-minimalist, soft-focus, monochrome ivory, tactile-porcelain, metallic-contrast, intimate-cropped; Aesthetic system: high-key lighting with translucent fabrics draped over a model cropped at lower face; matte-white sculptural bottle with engraved silver cap and tassel centrally; warm skin tones with cool metallic accents; shallow depth, soft grainless retouching, serif wordmark in elegant spacing.`,
  },
  {
    id: 6,
    title: "Visual AI: Key Visual cho skincare Meea Premium",
    description:
      "Thiết kế key visual cho thương hiệu dưỡng trắng Meea Premium theo phong cách K-beauty, dùng Midjourney và Magnific AI để tạo conversion-focused ad đạt chuẩn social media và e-commerce.",
    emoji: "🚀",
    bg: "from-indigo-100 to-blue-50",
    thumbnail: "/images/magnific-2.png",
    tags: ["Midjourney", "Magnific AI", "Beauty Design"],
    status: "Hoàn thành",
    content: `## Brief

PROJECT OVERVIEW: Product type: body skincare / whitening treatment system (3-step routine); Brand: Meea Premium; Category & purpose: beauty & personal care, promotional visual for a body whitening routine. The image functions as a conversion-focused ad (social media or e-commerce), showcasing a simplified regimen to achieve brighter skin.

PROBLEM STATEMENT: Core problem: consumers struggle with dull/uneven skin tone, ineffective or complicated whitening routines, and lack of trust in product results; Why this brand exists: to provide a simple, structured and effective whitening solution that feels accessible and safe; Market need: demand for visible brightening results, preference for step-by-step routines (guided skincare), desire for gentle yet effective products (exfoliation + fermented ingredients).

CORE CONCEPT: Main idea: "3-step transformation to brighter, glowing skin"; Creative logic: simplification (3 clear steps), visual reassurance (radiant skin result), product system (complete routine, not standalone); Symbolism: model's glowing skin = end result/aspiration, purple gradient = premium + gentle + modern femininity, sequential product display = process-driven transformation; Key theme: clean beauty + soft luxury + approachable transformation.

TARGET AUDIENCE: Female, ~18–35; beauty-conscious social media users, K-beauty inspired habits, value convenience + visible results; soft feminine aesthetics, easy-to-follow solutions, trend-driven ingredients ("fermented", "tone-up"); emotional triggers: desire for confidence, fear of dull skin, attraction to effortless glow.

KEY MESSAGE: Primary: "Achieve brighter, glowing skin in just 3 simple steps"; Steps: (1) Exfoliation, (2) Whitening mask (ủ trắng lên men), (3) Essence/lotion; Tagline: "Da sáng bật tone".

VISUAL STRATEGY: Right-heavy layout, model ~60% as emotional anchor, products + step explanation on left; hierarchy: headline, model face, products, brand logo; color palette: soft lavender/purple dominant, white and pastel pink supporting; high-key diffused lighting, minimal shadows, frontal soft fill; glossy packaging, smooth skin texture, matte background; shallow depth of field with model sharp and products softened; eye-level portrait, slight head tilt.

STYLE DNA: Keywords: soft premium, pastel beauty, clean skincare aesthetic, feminine minimalism, K-beauty inspired, glow-focused; aesthetic system: pastel gradient backgrounds, clean typography hierarchy, product grouping with subtle shadows, skin-first visuals, minimal clutter high readability.`,
  },
  {
    id: 7,
    title: "Visual AI: Hero Ad cho sneaker Nike",
    description:
      "Thiết kế hero campaign image cho dòng sneaker performance của Nike theo phong cách sporty-commercial, dùng Midjourney và Magnific AI để tạo visual đạt chuẩn social ad và OOH.",
    emoji: "🤖",
    bg: "from-pink-100 to-rose-50",
    thumbnail: "/images/magnific-3.jpg",
    tags: ["Midjourney", "Magnific AI", "Sport Design"],
    status: "Hoàn thành",
    content: `## Brief

PROJECT OVERVIEW: Product type: performance-oriented running/training sneaker; Brand: Nike (visible swoosh + logotype); Category & purpose: commercial product photography for footwear, hero lifestyle/commercial ad to showcase design, traction and active use in an aspirational outdoor setting.

PROBLEM STATEMENT: Core problem: communicate that this shoe delivers reliable traction, breathable comfort and style for active urban athletes while standing out in a crowded market; Why this brand exists: to provide high-performance stylish footwear bridging functional running features with everyday fashion; Market need: demand for versatile sneakers that perform during exercise but also read as modern lifestyle apparel, specifically improved grip, lightweight breathability and color-driven identity.

CORE CONCEPT: Main idea: a single decisive stride captured in close-up to communicate motion, grip and confidence — the shoe as the engine of movement; Symbolism: low-angle sole-forward frame positions the sneaker as momentum and upward progress (stride-as-aspiration); Key theme: athletic, energetic, modern with a sporty-studio-meets-outdoor aesthetic.

TARGET AUDIENCE: Age 18–35, all genders; urban runners, gym-goers and style-conscious consumers who value multifunctional gear, trend-forward colorways and social-media-ready visuals; emotional triggers: desire for capability (trust in performance), self-expression through color/style, aspirational rush of visible progress and confidence.

KEY MESSAGE: Primary: this sneaker delivers confident traction and dynamic performance while looking modern and stylish; Supporting: breathable engineering, lightweight design, street-to-run versatility; brand lockup with near "Just Do It." callout — primary intent is brand recall and attitude rather than specs.

VISUAL STRATEGY: Low-angle close-up with shoe occupying foreground-right vertical plane, sole angled toward camera to emphasize tread; secondary elements (pant cuff, horizon) provide context without competing; color palette: vibrant orange accents (energy, urgency), clean white upper (performance, purity), deep blue sky (open-air freedom); bright high-key sunlight with soft fill, slight rim lighting to separate from sky; breathable engineered mesh, molded foam midsole, textured rubber outsole with pronounced lugs; shallow depth of field keeping shoe sharp while background softens, dynamic low-angle tilt to imply motion and heroism.

STYLE DNA: Keywords: high-contrast, hyper-real, crisp commercial, sporty, vibrant-accent, minimal upper, textured outsole, low-angle hero; aesthetic system: bold accent color on functional elements (swoosh + outsole), clean white/neutral base with visible technical mesh, outdoors against saturated sky with high-key directional sunlight, low-angle close-ups foregrounding the sole, minimal bold brand lockup with short punchy copy in negative space.`,
  },
  {
    id: 8,
    title: "Visual AI: Hero Image cho dầu dưỡng tóc Kim Thoa",
    description:
      "Thiết kế hero image cho sản phẩm lotion tinh dầu hoa và vỏ bưởi Kim Thoa theo phong cách botanical minimalism, dùng Midjourney và Magnific AI để tạo visual đạt chuẩn e-commerce và social.",
    emoji: "📣",
    bg: "from-amber-100 to-yellow-50",
    thumbnail: "/images/magnific-4.png",
    tags: ["Midjourney", "Magnific AI", "Botanical Design"],
    status: "Hoàn thành",
    content: `## Brief

PROJECT OVERVIEW: Product type: topical hair-growth lotion spray made from botanical extracts; Brand: KIM THOA (label on bottle); Category & purpose: haircare product hero / marketing creative for e-commerce, social and POS, to present the product's natural ingredients and efficacy visually.

PROBLEM STATEMENT: Core problem: communicate product efficacy and natural origin quickly to build trust and drive purchase; Why this brand exists: to offer a plant-based, culturally rooted solution for slow or thinning hair that promises accelerated regrowth; Market need: consumer demand for visible, natural hair-growth treatments with clear ingredient provenance and credible, clean branding.

CORE CONCEPT: Main idea: literal ingredient storytelling, the product is framed with the primary botanical (pomelo peel and floral extracts) to visually prove origin and potency; Symbolism: the spiraled peel suggests renewal, unwrapping new growth and continuous regeneration; Key theme: natural-botanical, restorative, clean and trustworthy.

TARGET AUDIENCE: Adults 18–45, primarily female-skewed but unisex positioning; health- and beauty-conscious shoppers who prefer plant-based minimally processed cosmetics, active on social media and e-commerce; emotional triggers: desire for confidence through better hair, reassurance from visible natural ingredients, trust in simple honest packaging and quick promised results.

KEY MESSAGE: Primary: a natural lotion with flower and pomelo peel essential oils that accelerates hair growth; Supporting: fast emergence of baby hairs and quicker lengthening of existing hair; Tagline visible: "Lotion Tinh Dầu Hoa & Vỏ Bưởi", supporting bullets: "Nourishes for fast hair growth, new baby hairs appear, existing hair lengthens faster."

VISUAL STRATEGY: Two-zone layout, left typographic block, right arched crop featuring the bottle; foreground horizontal spiral peel anchors bottom third; bottle centered inside an arch cutout with wicker prop behind for warmth; color palette: primary greens (deep bottle green for efficacy/trust, medium olive/leaf green for natural freshness), off-white/linen background for purity, pale pink fruit flesh for delicate naturalness; soft high-key diffuse light from upper-left, minimal hard shadows, slight specular highlights on bottle; linen-textured backdrop, glossy dark-green plastic bottle with matte label, rough citrus peel texture, woven wicker for natural craft cues; eye-level product shot with shallow depth of field, foreground peel crisp, bottle slightly receded to create layered depth.

STYLE DNA: Keywords: botanical minimalism, fresh citrus, linen texture, muted natural greens, hand-lettered accent with bold sans headline, soft natural light, photorealistic detail; aesthetic system: single-product focus on an arched framed hero, prominent ingredient form as compositional anchor (spiraled peel), consistent linen backdrop and woven prop for warmth, two-part typographic system (script accent + bold green sans), restrained color grading favoring desaturated greens and high-key whites, shallow DOF to emphasize texture and authenticity.`,
  },
  {
    id: 9,
    title: "Visual AI: Brand Authority Campaign cho Bioderma Sensibio H2O",
    description:
      "Thiết kế campaign visual cho thương hiệu Bioderma Sensibio H2O theo phong cách clinical luxury, dùng Midjourney và Magnific AI để tạo banner đạt chuẩn dermo-cosmetic và e-commerce.",
    emoji: "💊",
    bg: "from-green-100 to-teal-50",
    thumbnail: "/images/magnific-5.png",
    tags: ["Midjourney", "Magnific AI", "Dermo Design"],
    status: "Hoàn thành",
    content: `## Brief

PROJECT OVERVIEW: Product type: micellar cleansing water (facial skincare); Brand: Bioderma, Sensibio H2O line; Category & purpose: dermatological skincare, brand authority campaign visual to reinforce market leadership, credibility and longevity.

PROBLEM STATEMENT: Core problem: consumers overwhelmed by cleansing product choices, skepticism around effectiveness and safety (especially sensitive skin), lack of trust in marketing claims vs. clinical credibility; Why this brand exists: to provide dermatologist-backed, gentle, effective cleansing solutions especially for sensitive skin; Market need: safe cleansing for sensitive skin, clinically trusted skincare, multi-functional minimal-step routines (cleanse + remove makeup).

CORE CONCEPT: Main idea: "#1 trusted cleansing solution for 30 years"; Creative strategy: use numeric dominance (1) to signal leadership, reinforce authority through repetition of "No.1" claims, combine science + beauty aesthetic; Symbolism: giant transparent "1" frame = market leadership made tangible, floating bubbles = micellar technology, clean bottle centered = purity/trust/simplicity; Key theme: clinical authority + modern beauty + trust validation.

TARGET AUDIENCE: Female skew but inclusive, age 20–40; skincare-aware and ingredient-conscious, values dermatologist recommendations, likely urban mid-high income; preferences: clean clinical branding, proven products over trendy gimmicks, minimal routines with high efficacy; emotional triggers: trust and safety (especially sensitive skin), social proof ("#1", dermatologist recommended), fear of irritation or wrong product choice.

KEY MESSAGE: Primary: "Bioderma Sensibio H2O is the #1 micellar cleansing solution"; Supporting: #1 in Europe, #1 unique cleansing ingredient (micellar tech), #1 bottle sold (high adoption), dermatologist recommended; Tagline: "30 năm khẳng định vị thế" (30 years of proven leadership).

VISUAL STRATEGY: Central composition with product as hero dominating frame; large "1" shape wraps around product as framing device; supporting claims in circular badges orbiting as authority cues; hierarchy: giant "1", product bottle, claim badges, brand logo; color palette: white (purity/dermatological safety), soft pink (sensitivity/gentleness), glass transparency (clarity/honesty), bright pink accent on cap; high-gloss studio lighting with strong reflections on glass, even illumination for clinical cleanliness; glass-like 3D frame, liquid transparency, soft gradients; sharp product focus with slight depth layering from floating elements; straight-on symmetrical framing for authority and trust.

STYLE DNA: Keywords: clinical luxury, transparent tech aesthetic, minimal + structured, scientific beauty, authority-driven design; aesthetic system: central hero product, geometric framing (numbers/shapes), floating info badges, glassmorphism effects, high polish reflections, limited color palette with one accent.`,
  },
];

export const VIDEOS = [
  {
    id: 1,
    title: "Video AI Quảng Cáo Thức Ăn Mèo Whiskas",
    duration: "0:58",
    views: "12.4K",
    emoji: "🐱",
    bg: "from-purple-100 to-pink-100",
    description:
      "Dự án tạo video quảng cáo AI cho thương hiệu Whiskas, từ concept đến output hoàn chỉnh.",
    url: "https://tiktok.com/@lomoai",
    embedUrl: "https://www.youtube.com/embed/VLfh0LmeABk",
    content: `Video quảng cáo AI cho thương hiệu thức ăn mèo Whiskas, được tạo hoàn toàn bằng các công cụ AI tạo video trên Freepik.

[youtube:pTnv2eJzvSA]

Đây là toàn bộ workflow sản xuất, từ brief đến output cuối, cho thấy cách AI có thể rút ngắn quy trình làm video quảng cáo chuyên nghiệp.`,
  },
  {
    id: 2,
    title: "Video AI Quảng Cáo KitKat đêm Giáng Sinh",
    duration: "1:02",
    views: "8.7K",
    emoji: "🎄",
    bg: "from-red-100 to-pink-100",
    description:
      "Dự án tạo video quảng cáo AI cho KitKat với concept ông già Noel vui cùng bầy tuần lộc đêm Giáng Sinh.",
    url: "https://tiktok.com/@lomoai",
    embedUrl: "https://www.youtube.com/embed/DRJD4YzmnlA",
    content: `Video quảng cáo AI cho KitKat với concept ông già Noel vui cùng bầy tuần lộc trong đêm Giáng Sinh, tạo hoàn toàn bằng công cụ AI tạo video trên Freepik.

[youtube:Om2HlI2Zm2M]

Đây là toàn bộ workflow sản xuất, cho thấy cách AI có thể tạo ra video quảng cáo mang không khí lễ hội chỉ trong thời gian ngắn.`,
  },
  {
    id: 3,
    title: "Video AI Quảng Cáo Gà Rán KFC",
    duration: "0:55",
    views: "21.1K",
    emoji: "🍗",
    bg: "from-orange-100 to-red-100",
    description:
      "Dự án tạo video quảng cáo AI cho KFC với concept vị ngon tỉnh táo cùng gà rán giòn rụm.",
    url: "https://tiktok.com/@lomoai",
    embedUrl: "https://www.youtube.com/embed/jhaf9sIz080",
    content: `Video quảng cáo AI cho KFC với concept vị ngon tỉnh táo cùng gà rán, tạo hoàn toàn bằng các công cụ AI tạo video trên Freepik.

[youtube:Ty2VIKoEFwc]

Đây là toàn bộ workflow sản xuất, cho thấy cách AI tạo ra video quảng cáo thực phẩm hấp dẫn từ đầu đến cuối.`,
  },
  {
    id: 4,
    title: "Video AI Quảng Cáo Nước Hoa Concept Nữ Mẫu Ảnh",
    duration: "",
    views: "",
    emoji: "🌸",
    bg: "from-rose-100 to-purple-100",
    description:
      "Dự án tạo video quảng cáo AI cho nước hoa với concept nữ mẫu ảnh sang trọng, tạo hoàn toàn bằng công cụ AI tạo video trên Freepik.",
    url: "https://www.youtube.com/watch?v=pTnv2eJzvSA",
    embedUrl: "https://www.youtube.com/embed/TitFO_TXcDQ",
    content: `Video quảng cáo AI cho nước hoa với concept nữ mẫu ảnh sang trọng, tạo hoàn toàn bằng công cụ AI tạo video trên Freepik.

[youtube:AQ6Gr3Lc3ds]

Đây là toàn bộ workflow sản xuất, cho thấy cách AI tạo ra video quảng cáo nước hoa mang tính thẩm mỹ cao từ đầu đến cuối.`,
  },
  {
    id: 5,
    title: "Video AI Quảng Cáo Sữa Rửa Mặt",
    duration: "",
    views: "",
    emoji: "🧴",
    bg: "from-sky-100 to-mint-pastel",
    description:
      "Dự án tạo video quảng cáo AI cho sữa rửa mặt bảo vệ da khỏi các tác nhân gây mụn sau ngày dài khói bụi.",
    url: "",
    embedUrl: "https://www.youtube.com/embed/R1HP0nSqIYk",
    content: `Video quảng cáo AI cho sữa rửa mặt với concept bảo vệ da khỏi các tác nhân gây mụn sau ngày dài mệt mỏi và khói bụi xe cộ, tạo hoàn toàn bằng công cụ AI tạo video trên Freepik.

[youtube:KRXRtV75Urg]

Đây là toàn bộ workflow sản xuất, cho thấy cách AI tạo ra video quảng cáo storytelling chân thực và gần gũi từ đầu đến cuối.`,
  },
];

export const FEEDBACKS = [
  {
    id: 1,
    type: "colleague",
    name: "Nhận xét",
    role: "Giảng viên Green Academy",
    avatar: "👨‍🏫",
    bg: "from-sky-100 to-blue-50",
    quote: "Giảng viên nhận xét về khả năng sáng tạo của tôi",
    date: "03/2026",
    embedUrl: "https://www.youtube.com/embed/jQHy1j-3haY",
    content: `Giảng viên nhận xét về khả năng sáng tạo của tôi`,
  },
  {
    id: 2,
    type: "colleague",
    name: "Nhận xét",
    role: "Giảng viên Green Academy",
    avatar: "👩‍💼",
    bg: "from-mint-pastel to-green-50",
    quote:
      "Giảng viên đánh giá cao việc áp dụng tốt kỹ thuật xóa phông xanh nhiều lớp",
    date: "08/2024",
    embedUrl: "https://www.youtube.com/embed/W-8pagcWy8k",
    content: `Giảng viên đánh giá cao việc áp dụng tốt kỹ thuật xóa phông xanh nhiều lớp`,
  },
  {
    id: 3,
    type: "colleague",
    name: "Nhận xét",
    role: "Giảng viên Green Academy",
    avatar: "🧑‍💻",
    bg: "from-beige-100 to-amber-50",
    quote:
      "Giảng viên đánh giá rất cao bản edit, kỹ thuật xử lý keyframe mượt mà và cách điều chỉnh tốc độ hợp lý. Phần nhạc nền mới được thay thế vô cùng ăn khớp với nhịp điệu hình ảnh, tạo nên một tổng thể hài hòa và cuốn hút. Sự đầu tư tỉ mỉ và công sức hoàn thiện một video dài hơn ba phút cũng được giảng viên ghi nhận là rất xuất sắc.",
    date: "09/2023",
    embedUrl: "https://www.youtube.com/embed/dxrA7-uphWY",
    content: `Giảng viên đánh giá rất cao bản edit, kỹ thuật xử lý keyframe mượt mà và cách điều chỉnh tốc độ hợp lý. Phần nhạc nền mới được thay thế vô cùng ăn khớp với nhịp điệu hình ảnh, tạo nên một tổng thể hài hòa và cuốn hút. Sự đầu tư tỉ mỉ và công sức hoàn thiện một video dài hơn ba phút cũng được giảng viên ghi nhận là rất xuất sắc.`,
  },
  {
    id: 4,
    type: "colleague",
    name: "Nhận xét",
    role: "Giảng viên Green Academy",
    avatar: "👩‍🏫",
    bg: "from-purple-100 to-violet-50",
    quote:
      "Giảng viên đánh giá cao sự sáng tạo và các ý tưởng thiết kế typography rất thú vị. Tuy nhiên, thầy góp ý cần chú ý đến độ tương phản nền, cách phối hợp phông chữ và phân cấp tỷ lệ chữ để làm nổi bật thông điệp chính. Ngoài ra, việc tinh chỉnh màu sắc tươi sáng hơn sẽ giúp tổng thể các thiết kế trở nên hoàn thiện và bắt mắt hơn.",
    date: "12/2025",
    embedUrl: "https://www.youtube.com/embed/4aoy_uGAFHg",
    content: `Giảng viên đánh giá cao sự sáng tạo và các ý tưởng thiết kế typography rất thú vị. Tuy nhiên, thầy góp ý cần chú ý đến độ tương phản nền, cách phối hợp phông chữ và phân cấp tỷ lệ chữ để làm nổi bật thông điệp chính. Ngoài ra, việc tinh chỉnh màu sắc tươi sáng hơn sẽ giúp tổng thể các thiết kế trở nên hoàn thiện và bắt mắt hơn.`,
  },
  {
    id: 5,
    type: "colleague",
    name: "Nhận xét",
    role: "Giảng viên Green Academy",
    avatar: "👨‍🏫",
    bg: "from-teal-100 to-cyan-50",
    quote: "Giảng viên khen ngợi bố cục thiết kế rất rõ ràng, đẹp mắt.",
    date: "05/2026",
    embedUrl: "https://www.youtube.com/embed/zrXeacYpgew",
    content: `Giảng viên khen ngợi bố cục thiết kế rất rõ ràng, đẹp mắt.`,
  },
  {
    id: 7,
    type: "customer",
    name: "Khách hàng",
    role: "Khách hàng",
    avatar: "🙂",
    bg: "from-pink-100 to-rose-50",
    quote: "",
    date: "2026",
    embedUrl: null,
    thumbnail: "/images/FB 3.png",
    content: ``,
  },
  {
    id: 8,
    type: "customer",
    name: "Khách hàng",
    role: "Khách hàng",
    avatar: "🙂",
    bg: "from-pink-100 to-rose-50",
    quote: "",
    date: "2026",
    embedUrl: null,
    thumbnail: "/images/FB 2.png",
    content: ``,
  },
  {
    id: 9,
    type: "customer",
    name: "Khách hàng",
    role: "Khách hàng",
    avatar: "🙂",
    bg: "from-pink-100 to-rose-50",
    quote: "",
    date: "2026",
    embedUrl: null,
    thumbnail: "/images/FB 1.png",
    thumbnailHeight: "72%",
    content: ``,
  },
];

export const RESUME = {
  education: [
    {
      school: "Học Viện Green Academy",
      degree: "Digital Marketing",
      period: "12/2025",
      note: "Tốt nghiệp",
    },
    {
      school: "Trường Đại học Nguyễn Tất Thành",
      degree: "Dược sĩ (Hệ Đại học)",
      period: "08/2023",
      note: "Tốt nghiệp loại Khá",
    },
    {
      school: "Học viện Kinh doanh BMG",
      degree: "Marketing Dược",
      period: "11/2022",
      note: "Tốt nghiệp",
    },
  ],
  experience: [
    {
      role: "Dược sĩ nhà thuốc phòng khám và làm Freelancer",
      org: "Phòng khám bác sĩ Võ Thanh Liêm",
      period: "06/2025 – nay",
      desc: "Dược sĩ tư vấn, soạn và cấp phát thuốc.",
    },
    {
      role: "Dược sĩ thực tập",
      org: "Nhà thuốc Pharmacity",
      period: "02/2025 – 04/2025",
      desc: "Sắp xếp, phân loại và bảo quản thuốc, tư vấn và hướng dẫn sử dụng thuốc, tham gia vào quy trình vận hành của kiểu hệ thống chuỗi nhà thuốc.",
    },
    {
      role: "Kinh doanh gia đình & làm Freelancer",
      org: "Gia đình",
      period: "11/2023 – 01/2025",
      desc: " ",
    },
    {
      role: "Thực tập sinh trình dược viên",
      org: "Công ty Cổ phần Dược phẩm Thiên Điền",
      period: "05/2022 – 06/2022",
      desc: "Giới thiệu các sản phẩm thuốc đến các nhà thuốc.",
    },
    {
      role: "Thực tập sinh",
      org: "Bệnh Viện Quận 8",
      period: "04/2022 – 05/2022",
      desc: "Tìm hiểu hoạt động thông tin giới thiệu thuốc trong bệnh viện, hội đồng thuốc và điều trị.\nKho thuốc trong bệnh viện theo hướng dẫn GSP.\nSắp xếp, phân loại và bảo quản thuốc tại khoa dược bệnh viện.\nCung ứng và cấp phát thuốc trong bệnh viện.",
    },
    {
      role: "Thực tập sinh nhà thuốc",
      org: "Nhà Thuốc Phúc Vinh",
      period: "03/2022 – 04/2022",
      desc: "Thực tập sinh quản lý, sắp xếp, phân loại và bảo quản thuốc.\nTư vấn và hướng dẫn sử dụng thuốc cho người mua.",
    },
  ],
  skills: [
    "SEO & SEM.",
    "Marketing & Content Marketing, Data Analytics",
    "Ứng dụng AI vào thiết kế UX/UI",
    "Kết hợp tư duy thiết kế để ứng dụng vào thực tiễn đọc Brief của dự án",
    "Thành thạo Word, Excel, PowerPoint",
    "Thiết kế, chỉnh sửa ảnh, video cơ bản bằng Capcut, Canva, Adobe Premiere...",
    "Thiết kế và vận hành hệ thống workflow AI :Freepik, Automation AI,...và nhiều công cụ AI. Khả năng phân tích tối ưu hóa chi phí sử dụng AI một cách hợp lý",
    "Giao tiếp, giải quyết vấn đề, quản lý thời gian, làm việc nhóm.",
    "Đọc hiểu tài liệu tiếng Anh chuyên ngành Dược",
  ],
  tools: [
    {
      name: "ChatGPT",
      icon: "https://www.google.com/s2/favicons?domain=chat.openai.com&sz=32",
    },
    {
      name: "Claude",
      icon: "https://www.google.com/s2/favicons?domain=claude.ai&sz=32",
    },
    {
      name: "Gemini",
      icon: "https://www.google.com/s2/favicons?domain=gemini.google.com&sz=32",
    },
    {
      name: "Perplexity",
      icon: "https://www.google.com/s2/favicons?domain=perplexity.ai&sz=32",
    },
    {
      name: "Midjourney",
      icon: "https://www.google.com/s2/favicons?domain=midjourney.com&sz=32",
    },
    {
      name: "Canva",
      icon: "https://www.google.com/s2/favicons?domain=canva.com&sz=32",
    },
    {
      name: "Notion AI",
      icon: "https://www.google.com/s2/favicons?domain=notion.so&sz=32",
    },
    {
      name: "CapCut AI",
      icon: "https://www.google.com/s2/favicons?domain=capcut.com&sz=32",
    },
    {
      name: "ElevenLabs",
      icon: "https://www.google.com/s2/favicons?domain=elevenlabs.io&sz=32",
    },
    {
      name: "Poe.com",
      icon: "https://www.google.com/s2/favicons?domain=poe.com&sz=32",
    },
    {
      name: "Suno AI",
      icon: "https://www.google.com/s2/favicons?domain=suno.ai&sz=32",
    },
    {
      name: "Freepik",
      icon: "https://www.google.com/s2/favicons?domain=freepik.com&sz=32",
    },
    {
      name: "Adobe",
      icon: "https://www.google.com/s2/favicons?domain=adobe.com&sz=32",
    },
    {
      name: "Higgsfield",
      icon: "https://www.google.com/s2/favicons?domain=higgsfield.ai&sz=32",
    },
    {
      name: "Manus",
      icon: "https://www.google.com/s2/favicons?domain=manus.im&sz=32",
    },
  ],
  whyHireMe: [
    {
      emoji: "01",
      title: "Tư duy đa ngành",
      desc: "Kết hợp chuyên môn Dược + Marketing + AI Design.",
    },
    {
      emoji: "02",
      title: "Biết dùng AI thực chiến",
      desc: "Thực sự tạo ra sản phẩm bằng Freepik, Midjourney, Higgsfield, ChatGPT, không chỉ biết tên tool.",
    },
    {
      emoji: "03",
      title: "Hiểu brief ngành sức khỏe",
      desc: "Khi làm content cho Y tế, Pharma hay Beauty, hiểu ngôn ngữ chuyên môn từ đầu. Giúp rút ngắn thời gian và giảm sai sót ở bước nội dung.",
    },
    {
      emoji: "04",
      title: "Triển khai được cả quy trình khi cần",
      desc: "Viết, thiết kế, dựng video, tự làm được từng bước. Không phải vì muốn làm một mình, mà vì biết đủ để không bị tắc khi thiếu người hỗ trợ.",
    },
    {
      emoji: "05",
      title: "Cẩn thận, tỉ mỉ là thói quen",
      desc: "Môi trường Dược đã rèn luyện thói quen cẩn thận. Tư duy xem lại trước khi hoàn thành là thứ tôi mang theo dù đang làm bài viết, thiết kế hay video.",
    },
    {
      emoji: "06",
      title: "Tiếp cận AI từ khi nó chưa được xem là kỹ năng",
      desc: "Tôi bắt đầu dùng AI để giải quyết vấn đề thực tế trong công việc từ khá sớm không phải vì xu hướng, mà vì đam mê học hỏi ứng dụng công nghệ .",
    },
    {
      emoji: "07",
      title: "Sau mỗi dự án là một lần nhìn lại có chủ đích",
      desc: "Tôi có thói quen ghi lại cái gì hiệu quả và cái gì không sau khi hoàn thành không để báo cáo, mà để lần sau làm tốt hơn dựa trên thứ đã thật sự xảy ra.",
    },
  ],
  certificates: [
    {
      name: "Digital Marketing",
      issuer: "Học Viện Green Academy",
      date: "12/2025",
      emoji: "🏅",
    },
    {
      name: "Pharmaceutical and Food Supplement Marketing Law",
      issuer: "The Thrive Hub",
      date: "04/2025",
      emoji: "🏅",
    },
    {
      name: "Dược sĩ Chuyên môn Nhà thuốc tại Alophar.vn",
      issuer: "Alophar.vn · Top 3 học viên có thành tích cao nhất khóa",
      date: "08/2024",
      emoji: "🏅",
    },
    {
      name: "Chuyên viên Marketing Dược",
      issuer: "Học viện Kinh doanh BMG",
      date: "11/2022",
      emoji: "📜",
    },
    {
      name: "Content Marketing Dược",
      issuer: "Brands Vietnam",
      date: "09/2023",
      emoji: "📝",
    },
    {
      name: "Microsoft Office Specialist (Word)",
      issuer: "Microsoft",
      date: "2018",
      emoji: "💻",
    },
  ],
  achievements: [
    {
      emoji: "💊",
      title: "Nền tảng chuyên môn Dược vững chắc",
      org: "",
      desc: "Tốt nghiệp Dược sĩ Hệ Đại học am hiểu sâu về sản phẩm, quy trình dược và ngôn ngữ chuyên ngành.",
    },
    {
      emoji: "📣",
      title: "Biết cách truyền thông chuyên ngành",
      org: "",
      desc: "Được đào tạo bài bản về Marketing Dược tại BMG và Content Marketing tại Brands Vietnam.",
    },
    {
      emoji: "🤝",
      title: "Kinh nghiệm thực tế đa môi trường",
      org: "",
      desc: "Thực tập tại nhà thuốc, bệnh viện, công ty dược hiểu cả 3 kênh phân phối thuốc.",
    },
    {
      emoji: "🏅",
      title: "Top 3 học viên xuất sắc",
      org: "",
      desc: "Hoàn thành khóa Dược sĩ Chuyên môn tại Alophar.vn với thành tích cao nhất khóa.",
    },
    {
      emoji: "🎯",
      title: "Tư duy Marketing thực chiến",
      org: "",
      desc: "Biết cách xây dựng nội dung, quảng bá sản phẩm và tiếp cận khách hàng đúng tệp mục tiêu.",
    },
    {
      emoji: "🛠️",
      title: "Thành thạo công cụ văn phòng & sáng tạo",
      org: "",
      desc: "Word (MOS certified), Excel, PowerPoint, Canva, Capcut, Adobe Premiere sẵn sàng làm việc ngay.",
    },
    {
      emoji: "🚀",
      title: "Học nhanh, thích nghi tốt",
      org: "",
      desc: "Tự học và ứng dụng được nhiều công cụ AI mới trong thời gian ngắn mà không cần background công nghệ.",
    },
    {
      emoji: "✍️",
      title: "Khả năng viết lách chuyên nghiệp",
      org: "",
      desc: "Viết content Y Dược rõ ràng, dễ hiểu phù hợp cả truyền thông nội bộ lẫn marketing ra ngoài.",
    },
    {
      emoji: "🌐",
      title: "Đọc hiểu tài liệu tiếng Anh chuyên ngành",
      org: "",
      desc: "Có thể nghiên cứu và tổng hợp tài liệu Dược quốc tế mở rộng nguồn thông tin không bị giới hạn.",
    },
    {
      emoji: "💡",
      title: "Tinh thần trách nhiệm & chủ động",
      org: "",
      desc: "Luôn hoàn thành đúng hạn, chủ động đề xuất giải pháp và sẵn sàng đảm nhận thêm trách nhiệm.",
    },
  ],
};
